<template>

  <!-- 最新年度の実績 -->
  <div>

    <!-- 実績値エラー表示 -->
    <div class="l-contentsSection error" 
      v-if="$v.nursingCare.maleNursingCareCount.$invalid
      || $v.nursingCare.femaleNursingCareCount.$invalid 
      || $v.nursingCare.maleShortTimeCount.$invalid 
      || $v.nursingCare.femaleShortTimeCount.$invalid 
      || $v.nursingCare.resultMemo.$invalid 
      || $v.nursingCare.actionMemo.$invalid">

      <div v-if="$v.nursingCare.maleNursingCareCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">介護休業取得者数（男性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.maleNursingCareCount.$invalid && !$v.nursingCare.maleNursingCareCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.maleNursingCareCount.$invalid && $v.nursingCare.maleNursingCareCount.numeric && !$v.nursingCare.maleNursingCareCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.nursingCare.femaleNursingCareCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">介護休業取得者数（女性）：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.femaleNursingCareCount.$invalid && !$v.nursingCare.femaleNursingCareCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.femaleNursingCareCount.$invalid && $v.nursingCare.femaleNursingCareCount.numeric && !$v.nursingCare.femaleNursingCareCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.nursingCare.maleShortTimeCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">短時間勤務者数（男性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.maleShortTimeCount.$invalid && !$v.nursingCare.maleShortTimeCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.maleShortTimeCount.$invalid && $v.nursingCare.maleShortTimeCount.numeric && !$v.nursingCare.maleShortTimeCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.nursingCare.femaleShortTimeCount.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">短時間勤務者数（女性）　：</span>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.femaleShortTimeCount.$invalid && !$v.nursingCare.femaleShortTimeCount.numeric" validation="numeric"/>
        <ValidationErrorMessage style="margin-left:20px;" v-show="$v.nursingCare.femaleShortTimeCount.$invalid && $v.nursingCare.femaleShortTimeCount.numeric && !$v.nursingCare.femaleShortTimeCount.between" validation="between" valueMin="0" valueMax="99999"/>
      </div>

      <div v-if="$v.nursingCare.resultMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">実績に関するメモ：</span>
        <ValidationErrorMessage v-show="$v.nursingCare.resultMemo.$invalid && !$v.nursingCare.resultMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
      <div v-if="$v.nursingCare.actionMemo.$invalid" style="padding-bottom:5px;">
        <span style="color:red; font-size: 1.5rem;margin-left: 20px;">具体的なアクション：</span>
        <ValidationErrorMessage v-show="$v.nursingCare.actionMemo.$invalid && !$v.nursingCare.actionMemo.maxLength" validation="maxLength" valueLength="300" />
      </div>
    </div>

    <!-- 実績値入力 -->
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">介護休業・短時間勤務取得者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
            <col style="width: 28%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>介護休業<br>取得者</th>
              <th>短時間勤務<br>取得者数</th>
              <th>合計</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.nursingCare.$model.maleNursingCareCount" type="text" name="nursingCare.maleNursingCareCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.nursingCare.$model.maleShortTimeCount" type="text" name="nursingCare.maleShortTimeCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <Currency :value="this.sumOfMaleCount" :unit="this.unit1"/>
                </div>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.nursingCare.$model.femaleNursingCareCount" type="text" name="nursingCare.femaleNursingCareCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <TextBox v-model.trim="$v.nursingCare.$model.femaleShortTimeCount" type="text" name="nursingCare.femaleShortTimeCount" class="u-tac" @input="changeInput()"></TextBox>
                  <span class="human-capitalt-data-table__unit">名</span>
                </div>
              </td>
              <td>
                <div class="human-capitalt-data-table__input has-unit">
                  <Currency :value="this.sumOfFemaleCount" :unit="this.unit1"/>
                </div>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfNursingCount" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfShortTimeCount" :unit="this.unit1"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><strong><Currency :value="this.calcAchievementNursingCareLeave" :unit="this.unit1"/></strong></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
            <p v-if="this.num==0" class="l-memo-note">現状の課題や、課題に対してのアドバイスをメモしましょう。</p>
              <TextArea class="l-formGroup__textArea is-highMiddle" v-model="nursingCare.resultMemo" @input="changeInput()" ></TextArea>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo" ref="memoEdit">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
              <button class="link-arrow is-normal js-memo-edit" @click="editMode()">編集する</button>
              <button class="link-arrow is-edit js-memo-exit" @click="editMode()">編集を終わる</button>
            </div>
            <p v-if="this.num==0" class="l-memo-note">今後どういった取り組みをしていくかをメモしましょう。<br>レポート画面からも入力できます。</p>
            <div class="l-contentsMemo__body">
              <div class="l-grayBox is-normal" style="min-height:108px;">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(nursingCare.actionMemo)"></p>
                </div>
              </div>
            </div>
            <TextArea class="l-formGroup__textArea is-highMiddle is-edit" v-model="nursingCare.actionMemo" @input="changeInput()"></TextArea>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2-->
  </div>
</template>

<script>
import TextBox from '@/components/parts/form/TextBox.vue';
import ValidationErrorMessage from '@/components/parts/form/ValidationErrorMessage.vue';
import TextArea from '@/components/parts/form/TextArea.vue';
import { numeric, between, maxLength } from 'vuelidate/lib/validators';
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    TextBox,
    ValidationErrorMessage,
    TextArea,
    Currency,
  },
  props: {
    // 表示年度の介護休業・短時間勤務取得者数データ
    nursingCare: {},
    num: null,
  },
  data() {
    return {
      isAnswerChanged:false,
      unit1: "名",
      unit2: "％",
    }
  },
  computed: {
    sumOfMaleCount() {

      if ( !(this.nursingCare.maleNursingCareCount!=null && this.nursingCare.maleShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.maleNursingCareCount).length * String(this.nursingCare.maleShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.maleNursingCareCount) || isNaN(this.nursingCare.maleShortTimeCount)) {
        return null;
      }else{
        return Number(this.nursingCare.maleNursingCareCount) + Number(this.nursingCare.maleShortTimeCount);
      }
    },
    sumOfFemaleCount() {
      if ( !(this.nursingCare.femaleNursingCareCount!=null && this.nursingCare.femaleShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.femaleNursingCareCount).length * String(this.nursingCare.femaleShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.femaleNursingCareCount) || isNaN(this.nursingCare.femaleShortTimeCount)) {
        return null;
      }else{
        return Number(this.nursingCare.femaleNursingCareCount) + Number(this.nursingCare.femaleShortTimeCount);
      }
    },
    sumOfNursingCount() {
      if ( !(this.nursingCare.maleNursingCareCount!=null && this.nursingCare.femaleNursingCareCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.maleNursingCareCount).length * String(this.nursingCare.femaleNursingCareCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.maleNursingCareCount) || isNaN(this.nursingCare.femaleNursingCareCount)) {
        return null;
      }else{
        return Number(this.nursingCare.maleNursingCareCount) + Number(this.nursingCare.femaleNursingCareCount);
      }
    },
    sumOfShortTimeCount() {
      if ( !(this.nursingCare.maleShortTimeCount!=null && this.nursingCare.femaleShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.nursingCare.maleShortTimeCount).length * String(this.nursingCare.femaleShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.nursingCare.maleShortTimeCount) || isNaN(this.nursingCare.femaleShortTimeCount)) {
        return null;
      }else{
        return Number(this.nursingCare.maleShortTimeCount) + Number(this.nursingCare.femaleShortTimeCount);
      }
    },
    calcAchievementNursingCareLeave() {
      if ( !(this.sumOfNursingCount!=null && this.sumOfShortTimeCount!=null) ) {
        return null;
      }else if ( String(this.sumOfNursingCount).length * String(this.sumOfShortTimeCount).length == 0) {
        return null;
      }else if ( isNaN(this.sumOfNursingCount) || isNaN(this.sumOfShortTimeCount)) {
        return null;
      }else{
        return Number(this.sumOfNursingCount) + Number(this.sumOfShortTimeCount);
      }
    },
  },
  validations: {
    nursingCare: {
      maleNursingCareCount : { numeric, between: between(0,99999) },    // 介護休業取得者数（男性）
      femaleNursingCareCount : { numeric, between: between(0,99999) },  // 介護休業取得者数（女性）
      maleShortTimeCount : { numeric, between: between(0,99999) },      // 短時間勤務者数（男性）
      femaleShortTimeCount : { numeric, between: between(0,99999) },    // 短時間勤務者数（女性）
      resultMemo: { maxLength: maxLength(300) }, // 実績メモ
      actionMemo: { maxLength: maxLength(300) }, // アクションメモ
    }
  },
  watch: {
    nursingCare() {
      this.inputNursingCare();
    }
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputNursingCare() {
      this.$emit("change-nursing-care", {
        nursingCare: this.nursingCare,
        num: this.num,
      });
    },
    // アクションメモの編集モード切替
    editMode(isEdit){
      const memoElm = this.$refs.memoEdit
      if ( isEdit == null || memoElm.classList.contains("is-edit") ){
        memoElm.classList.toggle("is-edit");
      }
    },
    // 文字列中のURLをaタグに変換する
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },
    // 編集フラグの取得（メイン画面の画面遷移時に呼び出されてチェックする）
    getIsAnswerChanged(){
      return this.isAnswerChanged; 
    },
    // 入力データ編集フラグ
    changeInput(){
      this.isAnswerChanged = true
    },
    setIsAnswerChanged(flag){
      this.isAnswerChanged = flag;
    }
  }
}

</script>
